/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-02-22, 14:12:43
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-02-26, 15:00:56
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */
import { API, API_URL } from '@/config';
import { togglePendingStoreActions } from '@/utils/decorators';

import {
  COMPLETE_RECHARGES_LIST, SET_RECHARGES_TERMS,
} from './mutation-types';

export default {
  setRechargesTerms({ dispatch, commit, state }, newTerms = {}) {
    const terms = { ...state.rechargesList.terms, ...newTerms };
    commit(SET_RECHARGES_TERMS, { terms });
    return Promise.resolve();
  },

  @togglePendingStoreActions()
  async getRechargesList({ commit, state }) {
    const { dateStart, dateEnd, sort, sortBy } = state.rechargesList.terms;
    const params = {
      from: dateStart,
      to: dateEnd,
      sortby: sortBy,
      sort,
    };
    const rechargesList = (await API.get(`${API_URL}/recharges`, { params })).data.data;
    commit(COMPLETE_RECHARGES_LIST, { rechargesList });
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/Recharges/actions.js